import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { appActions } from 'store/app/appSlice';
import { selectQuiz } from 'store/quiz/quizzesSelectors';
import { selectQuizFormMenuItem } from 'store/app/appSelectors';
import IQuiz from 'models/Quiz';
import IQuestion from 'models/Question';
import IPage from 'models/Page';
import PageTypes from 'types/PageTypes';
// Components
import MenuItem from './MenuItem';

const CorrectAnswersMenu:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const { watch } = useFormContext();
  const watchedEndsDate = watch('endsDate');
  
  const quiz:IQuiz | null = useAppSelector(selectQuiz);
  const quizFormMenuItem = useAppSelector(selectQuizFormMenuItem);

  const questionsPages = quiz?.pages?.filter((page:IPage) => page.type === PageTypes.Question);
  const questions:IQuestion[] = quiz?.questions.filter(question => questionsPages?.some(page => page.refs.includes(question.ref))) || [];

  useEffect(() => {
    dispatch(appActions.setQuizFormMenuItem('correct-answer-0'));
    // eslint-disable-next-line
  }, []);

  if (!quiz || +watchedEndsDate >= new Date().getTime()) return null;
  return (
    <div className="flex flex-col flex-grow bg-content rounded-xl">
      {questions.map((question, index) => (
        <MenuItem
          key={`correct-answer-${index}`}
          menuItem={{
            icon: 'help',
            label: `${t('labels.question')} ${index + 1}`,
            value: `correct-answer-${index}`
          }}
          active={quizFormMenuItem === `correct-answer-${index}`}
          forceExpande={true}
        />
      ))}
    </div>
  )
}

export default CorrectAnswersMenu;
